module.exports = __webpack_public_path__ + "static/img/7.803e18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/7.png
// module id = D6U3
// module chunks = 0